import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import store from './store'

// BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false
Vue.filter('formatNumberMoney', function (value, currency) {
  var result = ''
  if (currency == 'COP') {
    result = parseInt(value).toLocaleString('es-CO', { currency: 'COP', style: 'currency' })
  } else if (currency == 'USD') {
    result = parseInt(value).toLocaleString('en-US', { currency: 'USD', style: 'currency' })
  } else if (currency == 'CAD') {
    result = parseInt(value).toLocaleString('en-CA', { currency: 'CAD', style: 'currency' })
  }
  return result
})

if (process.env.NODE_ENV === 'production') {
  // URL CDN IMAGENES
  Vue.prototype.$cdn = 'https://cdn.systemico.net/systemico/'
  Vue.prototype.$paymentsHost = 'https://systemico.net/pay/'
  Vue.prototype.$baseDomainDevelopment = ''
  Vue.prototype.$baseDomainProducts = 'https://systemico.net'
}
else {
  // URL CDN IMAGENES
  Vue.prototype.$cdn = 'https://cdn.systemico.net/systemico/'
  Vue.prototype.$paymentsHost = 'https://systemico.net/pay/'
  Vue.prototype.$baseDomainDevelopment = ''
  Vue.prototype.$baseDomainProducts = 'https://systemico.net'
}

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
